import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button } from "react-bootstrap";
import ReactJson from 'react-json-view'


const log = (type) => console.log.bind(console, type);




/*

# VAR MODIFY

Function to edit the json in variables section

The value field can be of different types which causes library to break when changing what the expected type of this field is changed
eg boolean to an array it falls over.


one option is to change the field to value_x field and enable and disable each one accordingly

["array","RGB_Colour","CONTACT_LIST"]



"String",
"Number",
"True / False",
"String Array",
"RGB Colour",
"CONTACT_LIST"




*/



//value: {type: "string", title: "Inital Value"},
var varForm={
      schema:{
        title: "Var Edit",
        type: "object",
        required: ["id","name"],
        properties: {
          type: {type: "string", title: "Type of variable", default: "string" ,
          enum: [
              "string",
              "number",
              "boolean",
              "array",
              "RGB_Colour",
              "CONTACT_LIST"
          ],
          enumNames: [
            "String",
            "Number",
            "True / False",
            "String Array",
            "RGB Colour",
            "Contact List",
            ]
          },
          name: {type: "string", title: "Description of the variable", default: "New Variable"},
          id: {type: "string", title: "ID of the variable (must be unique)", default: "VAR_NAME"},
          user: { "type": "boolean", "title": "user",  default:true },
          broadcast: { "type": "boolean", "title": "Broadcast", "description": "Broadcast when this variable changes value", default:false},
          log: { "type": "boolean", "title": "log", "description": "Log when this variable changes", default:false},
          override: { "type": "boolean", "title": "Override", "description": "sets the inital value when system restarts", default:true }
        },
        dependencies:{
                type: {
                  oneOf: [
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "string"
                          ]
                        },
                        "value": {
                          "title": "String",
                          "type": "string"
                        }
                      }
                    },
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "number"
                          ]
                        },
                        "value": {
                          "title": "Number",
                          "type": "number"
                        }
                      },
                      "required": [
                        "value"
                      ]
                    },
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "boolean"
                          ]
                        },
                        "value": {
                          "title": "True False",
                          "description": "Value has 2 states True or False",
                          "type": "boolean"
                        }
                      },
                      "required": [
                        "value"
                      ]
                    },
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "RGB_Colour"
                          ]
                        },
                        "value": {

                          "type": "object",
                          "description":"RGB Colour",
                          "properties": {
                            "red": {type:"number" ,title:"Red (0-255)", minimum:0 , maximum:255 ,default:0},
                            "green": {type:"number",title:"Green (0-255)", minimum:0 , maximum:255,default:0},
                            "blue": {type:"number",title:"Blue (0-255)", minimum:0 , maximum:255,default:0},
                            "time": {type:"number",title:"Ramp time (0-9)" ,minimum:0 , maximum:255,default:0}
                          }
                        }
                      }
                    },
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "array"
                          ]
                        },
                        "value": {
                          "title": "String List",
                          "type": "array",
                          "items": {
                            "type": "string",
                            "placeholder": "String"
                          }
                        }
                      }
                    },
                    {
                      "properties": {
                        "type": {
                          "enum": [
                            "CONTACT_LIST"
                          ]
                        },
                        "value": {
                          "title": "Contact List",
                          "type": "array",
                          "description":"Email or Mobile number",
                          "items": {
                            "type": "string",
                            "placeholder": "mobile or email"
                          }
                        }
                      }
                    }
                  ]
                },
        }




      },
      uiSchema:{
        id:   {"ui:readonly":true},
        user: {"ui:widget": "hidden"},
        value: {
          "ui:options": {orderable: false  },

        },
        type:{
          "ui:enumDisabled": ["array","RGB_Colour","CONTACT_LIST"],
          "ui:emptyValue":[],


      }

      },




}


  //  type:{"ui:enumDisabled": ['number']}



export default class VarModifyAll extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        advancedEdit:false
      };
    }
    componentWillMount() {

      console.log(this.props.data)
      this.setState({data:this.props.data})
      varForm.uiSchema.id["ui:readonly"]=!this.props.editMode
      this.setState({editMode:false})
    //  actionForms.macro.schema.properties.data.enum=["TEST1","TEST2","TEST3"]
    }
    onChangeValue=(d)=>{
      let temp=this.state.data
      console.log(temp)
      console.log(d)
      temp.value=d.formData.value
      console.log(temp)
      this.setState({data:temp})
    }


      validate=(d,errors)=>{
          console.log("Validate?")
          console.log(d)
          console.log(errors)

          return errors

      }

    onChange=(d)=>{

      if(this.state.data.type!=d.formData.type){
        console.log("Type Change")
        d.formData.value=[]
        console.log(d.formData)
      }
      this.setState({data:d.formData})
              console.log(d.formData)
    }

    onBlur=(d)=>{
      console.log("onBlur")
    }


    jsonEdit=(d)=>{
      console.log("Edit")
      console.log(d)
      if(typeof(d.existing_value)!=typeof(d.new_value)){
        alert("The Type has changed this key was a "+typeof(d.existing_value))
      }
      this.setState({data:d.updated_src})
      console.log(this.state.data)
    }

    delete=()=>{

      let temp=this.state.data
      let data={
        cmd:"vars",
        type:"delete",
        id:temp.id
      }
      this.props.callback(data)


    }


    static getDerivedStateFromError(error) {
        // This is here to catch issues with a invalid value being present when the variable type is changed
        //Eg type is changed to array when the value was previouslt a boolean the library doesnt like it.


        console.log("ERRRORRRORORORORR")
      }

    submit=(d)=>{
      console.log(d)
      if (d.formData.id.length>0){
      let data={
        cmd:"vars",
        type:"modify",
        id:d.formData.id,
        data:d.formData
      }
      console.log(data)
      this.props.callback(data)
      }
    }

    submitAdvanced=()=>{
      let temp=this.state.data
      let data={
        cmd:"vars",
        type:"modify",
        id:temp.id,
        data:temp
      }
      this.props.callback(data)


    }

    jsonAdd=(d)=>{
      console.log("Add")
      console.log(d)
    }

    jsonDelete=(d)=>{
      console.log("delete")
      console.log(d)
      if(d.name=="cmd"){
        alert("cmd is always required")
        return false
      }
    }

    goAdvanced=()=>{
      console.log("Change edit")
      this.setState({advancedEdit:!this.state.advancedEdit})
    }

    cancel=()=>{
      console.log("Cancel")
      this.props.callback({"cmd":"cancel"})

    }


    componentWillUnmount(){
      console.log("Unmount")

    }


    render(){
      const validForm=true
      let vartype=this.props.type
    //  console.log("Form Edit")
      //console.log(validForm)
      if(validForm==true && this.state.advancedEdit==false){
        return (<span>

          <Form
                safeRenderCompletion={true}
                schema={varForm.schema}
                uiSchema={varForm.uiSchema}
                formData={this.state.data}
                 onChange={this.onChange}
                 onSubmit={this.submit}
                 onError={log("errors")}
                 onBlur={this.onBlur}
                 validate={this.validate}
                 >

                 <Button type="submit">Save</Button>
                 <Button type="button" onClick={this.cancel}>Cancel</Button>
                 {!this.props.editMode?(<Button type="button" onClick={this.delete}>Delete List</Button>):("")}
                    <Button className="pull-right" onClick={this.goAdvanced}>Advanced</Button>
                 </Form>
          </span>
        )
      }
      else{
        return (
              <div>
                  <h4>Advanced edit for `{this.state.data.cmd}`, displaying JSON</h4>
                  <div className="jsonPAD">
                  <ReactJson  theme="solarized"  name={false} src={this.state.data}  enableClipboard={false} displayObjectSize={false} displayDataTypes={false} onEdit={this.jsonEdit} onDelete={this.jsonDelete} onAdd={this.jsonAdd}/>
                  </div>
                  <Button onClick={this.submitAdvanced}>Save</Button>
                  <Button type="button" onClick={this.cancel}>Cancel</Button>
                   {validForm ? (<Button className="pull-right" onClick={this.goAdvanced}>Form view</Button>):(<span></span>)}
              </div>

        )

}





    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/VarModifyAll.js